export default __webpack_public_path__ + "static/media/diamond.4eceb7d7.svg";